import { Device } from "../api/devices";

/**
 * Marca e modello di un device fisico, nella forma che i form usano per i
 * propri campi Marca/Modello.
 *
 * Sta qui e non dentro i form perché la regola è una sola e la applicano in
 * due (Installazioni e Attivazioni): scritta due volte, divergerebbe come è
 * già successo per l'azzeramento di `sede_id` — vedi il commento in
 * `SedeAutocomplete`.
 *
 * ## Tre casi, non uno
 *
 * Un device è collegato al Catalogo Dispositivi solo se la riconciliazione è
 * riuscita. Quando c'è, marca e modello sono due campi distinti e si copiano
 * tali e quali, insieme all'id del modello: è l'unico caso in cui il form può
 * anche mostrare la documentazione collegata.
 *
 * Quando non c'è resta `modello_raw`, che è una stringa sola come l'ha scritta
 * la fonte — «YOUGO U-Bundle 4000», marca e modello attaccati. Spezzarla al
 * primo spazio sarebbe un indovinello: «U-BUNDLE 4000» e «Yougo U-ONE 2000E»
 * si dividerebbero in punti diversi, e una marca sbagliata è peggio di una
 * casella vuota perché sembra un dato. Quindi finisce tutta nel modello e la
 * marca si SVUOTA: la marca c'è già dentro quella stringa, e lasciarci quella
 * del pezzo scelto un momento prima farebbe leggere «YOUGO / YOUGO U-Bundle
 * 4000», cioè due campi che si contraddicono.
 *
 * Se il device non ha né l'uno né l'altro non si sa niente di lui: `null` in
 * entrambi, e i campi si lasciano **come stanno**. Svuotarli sarebbe togliere
 * quello che l'utente aveva scritto per sostituirlo con niente.
 */
export function modelloDaDevice(device: Device): {
  /** `null` = non ricavabile, il campo va lasciato com'è. `""` = da svuotare. */
  marca: string | null;
  modello: string | null;
  /**
   * Chiave del modello a catalogo, `null` se il pezzo non ne ha uno.
   *
   * A differenza dei due campi di testo questa **va sempre scritta**, `null`
   * compreso: è una chiave, e una chiave rimasta indietro collega il record a
   * un modello diverso da quello scritto accanto — lo stesso difetto che
   * `SedeAutocomplete` risolve per `sede_id`. Senza, scegliere un pezzo a
   * catalogo e poi cambiarlo con uno non censito lasciava a schermo la scheda
   * del modello di prima.
   */
  catalogoId: string | null;
} {
  if (device.dispositivo_catalogo) {
    return {
      marca: device.dispositivo_catalogo.marca,
      modello: device.dispositivo_catalogo.modello,
      catalogoId: device.dispositivo_catalogo.id,
    };
  }
  if (device.modello_raw) return { marca: "", modello: device.modello_raw, catalogoId: null };
  return { marca: null, modello: null, catalogoId: null };
}
